import { getCoursesBrand } from "common/api/decimal/methods/course.ts";

export interface SignInPromptData {
  signInUrl: string;
}

/**
 * A 404 on the context/terms call can mean the user's Bookshelf account
 * isn't matched to an LMS/SIS record (VBS + IDP-enabled brands only).
 * getCoursesBrand() resolves purely from the brand (referrer/override), not
 * the unmatched user, so it succeeds even when the context/terms call 404s.
 */
export const buildNoCoursesResponse = async (
  statusText: string
): Promise<Response> => {
  const brandResult = await getCoursesBrand();
  const signInUrl = brandResult.ok
    ? brandResult.data?.sal.contentAccessUrl
    : null;
  if (signInUrl) {
    const signInPrompt: SignInPromptData = { signInUrl };
    return new Response(JSON.stringify(signInPrompt), {
      status: 404,
      statusText,
      headers: { "Content-Type": "application/json" },
    });
  }
  return new Response("Not Found", { status: 404, statusText });
};
